import './JobDescription.scss';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Button, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import {
  JobData,
  JobUserAssigned,
  MATCH,
  User,
} from 'components/JobQueue/utils';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { timeSince } from 'utils/ArrayConstants';

// import { MASTER_ENDPOINT } from 'utils/Constant';
import UserAssignModal from '../JobQueue/UserAssignModal';
import CloseJobComponent from './CloseJobComponent';

interface HeaderProps {
  jobTitle: string;
  company: string;
  location: string;
  timePosted: string;
  billRate: string;
  source: string;
  assignedUsers?: JobUserAssigned[];
  onBack: () => void;
  onCloseJob: () => void;
  users: User[];
  jobId: string;
  jobData?: JobData;
  Params?: any;
  sourceLink?: string;
  isJobClose?: boolean;
  statusReason?: string;
}

const Header: React.FC<HeaderProps> = ({
  jobTitle,
  company,
  location,
  timePosted,
  billRate,
  source,
  onBack,
  onCloseJob,
  assignedUsers: exisitngAssignedUsers,
  users,
  jobId,
  jobData,
  Params,
  sourceLink,
  isJobClose,
  statusReason,
}) => {
  const navigate = useNavigate();
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [assignedUsers, setAssignedUsers] = useState<JobUserAssigned[]>([]);
  const [closeJobModalOpen, setCloseJobModalOpen] = useState(false);
  const [statusViewModalOpen, setStatusViewModalOpen] = useState(false);

  const handleAssignClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setAssignModalOpen(true);
  };

  const handleAssignUser = (userId: string, type: 'add' | 'remove') => {
    if (type === 'remove') {
      const updatedAssignedUsers = assignedUsers.filter(
        (user) => user.userId !== userId,
      );
      setAssignedUsers(updatedAssignedUsers);
      setAssignModalOpen(false);
      setAnchorEl(null);
      return;
    }
    const userInfo = users.find((user) => user.id === userId);
    if (userInfo) {
      const newAssignedUser: JobUserAssigned = {
        assignedByFirstName: '',
        assignedByImageId: '',
        assignedByLastName: '',
        assignedByUserName: '',
        assignedToFirstName: userInfo?.firstName,
        assignedToImageId: userInfo?.imageId || null,
        assignedToLastName: userInfo?.lastName,
        assignedToUserName: userInfo?.firstName + ' ' + userInfo?.lastName,
        createdBy: userInfo.createdBy,
        id: userId,
        jobId,
        userId: userId,
      };
      setAssignedUsers((prev) => [...prev, newAssignedUser]);
    }
    setAssignModalOpen(false);
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setAssignModalOpen(false);
    setAnchorEl(null);
  };

  const handleOpenCloseJobModal = () => {
    setCloseJobModalOpen(true);
  };

  const handleCloseJobModal = () => {
    setCloseJobModalOpen(false);
    onCloseJob();
  };

  const handleOpenStatusView = () => {
    setStatusViewModalOpen(true);
  };

  const handleCloseStatusView = () => {
    setStatusViewModalOpen(false);
  };

  React.useEffect(() => {
    if (exisitngAssignedUsers && exisitngAssignedUsers.length > 0)
      setAssignedUsers(exisitngAssignedUsers || []);
  }, [exisitngAssignedUsers]);

  return (
    <div
      style={{
        backgroundColor: '#FAFAFB',
        borderBottom: '1px solid #ECECEC',
        padding: '20px',
      }}>
      {/* Job Details Row */}
      <div
        style={{
          alignItems: 'baseline',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}>
        <div
          style={{
            alignItems: 'flex-start',
            display: 'flex',
            gap: '2px',
          }}>
          {/* Top Row - Back Button and Job Title */}
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
            }}
            onClick={() => {
              // Detect basePath from current URL (e.g., /sales or /management)
              const pathSegments = window.location.pathname
                .split('/')
                .filter(Boolean);
              const basePath =
                pathSegments.length > 0 ? `/${pathSegments[0]}` : '/sales';
              navigate(`${basePath}/job-queue`, { state: { Params: Params } });
            }}>
            <IconButton
              onClick={onBack}
              sx={{
                '&:hover': {
                  backgroundColor: '#f3f4f6',
                },
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                marginRight: '12px',
                padding: '8px',
              }}>
              <ArrowBackIcon sx={{ color: '#6b7280', fontSize: '20px' }} />
            </IconButton>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}>
            <Typography
              sx={{
                color: '#242424',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '20px',
              }}>
              {jobTitle}
            </Typography>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '4px',
              }}>
              <Typography
                sx={{
                  display: 'flex',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontWeight: 400,
                  gap: '6px',
                  lineHeight: '22px',
                }}>
                <span
                  style={{
                    color: '#242424',
                  }}>
                  {' '}
                  {company ? company : ''}{' '}
                </span>{' '}
                {location.length > 0 && (
                  <span
                    style={{
                      alignSelf: 'center',
                      backgroundColor: '#0E700E',
                      borderRadius: '100%',
                      height: '4px',
                      marginRight: '6px',
                      width: '4px',
                    }}
                  />
                )}{' '}
                <span
                  style={{
                    color: '#6b7280',
                  }}>
                  {location}{' '}
                </span>{' '}
                <span
                  style={{
                    alignSelf: 'center',
                    backgroundColor: '#0E700E',
                    borderRadius: '100%',
                    height: '4px',
                    marginRight: '6px',
                    width: '4px',
                  }}
                />
                <span
                  style={{
                    color: '#6b7280',
                  }}>
                  {' '}
                  {timeSince(timePosted)} ago{' '}
                </span>
              </Typography>
            </div>
            {/* Tags */}
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                gap: '8px',
                marginTop: '12px',
              }}>
              <Chip
                icon={
                  <div
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      height: '6px',
                      width: '6px',
                    }}
                  />
                }
                label={
                  MATCH.find(
                    (item) => item.key === jobData?.candidateMatchStatus,
                  )?.label
                }
                sx={{
                  '& .MuiChip-icon': {
                    color: 'white',
                    marginLeft: '8px',
                  },
                  '& .MuiChip-label': {
                    lineHeight: '14px',
                  },
                  backgroundColor: MATCH.find(
                    (item) => item.key === jobData?.candidateMatchStatus,
                  )?.bgColor,
                  border:
                    '1px solid ' +
                    MATCH.find(
                      (item) => item.key === jobData?.candidateMatchStatus,
                    )?.borderColor,
                  color: 'white',
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: 600,
                  height: '20px',
                }}
              />
              <Chip
                label={`Bill Rate • ${billRate}`}
                sx={{
                  '& .MuiChip-label': {
                    lineHeight: '14px',
                  },
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #dbdbdb',
                  color: '#7c7c7c',
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: 600,
                  height: '20px',
                }}
              />
              {source &&
              ['email', 'manual'].includes(String(source).toLowerCase()) ? (
                <Chip
                  label={source?.toUpperCase()}
                  sx={{
                    '& .MuiChip-label': {
                      lineHeight: '14px',
                      padding: '0 2px',
                    },
                    backgroundColor: '#FFE3E3',
                    border: '1px solid #E87979',
                    color: '#C32424',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontWeight: 600,
                    height: '20px',
                    padding: '2px 4px',
                    textTransform: 'capitalize',
                  }}
                />
              ) : sourceLink ? (
                <Tooltip title={sourceLink} arrow>
                  <Chip
                    label={source?.toUpperCase()}
                    component="a"
                    href={sourceLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    clickable
                    aria-label={`Open source link ${sourceLink}`}
                    sx={{
                      '& .MuiChip-label': {
                        lineHeight: '14px',
                        maxWidth: 200,
                        overflow: 'hidden',
                        padding: '0 2px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      },
                      backgroundColor: '#FFE3E3',
                      border: '1px solid #E87979',
                      color: '#C32424',
                      fontFamily: 'Inter',
                      fontSize: '10px',
                      fontWeight: 600,
                      height: '20px',
                      padding: '2px 4px',
                      textTransform: 'none',
                    }}
                  />
                </Tooltip>
              ) : source ? (
                <Chip
                  label={source?.toUpperCase()}
                  sx={{
                    '& .MuiChip-label': {
                      lineHeight: '14px',
                      padding: '0 2px',
                    },
                    backgroundColor: '#FFE3E3',
                    border: '1px solid #E87979',
                    color: '#C32424',
                    fontFamily: 'Inter',
                    fontSize: '10px',
                    fontWeight: 600,
                    height: '20px',
                    padding: '2px 4px',
                    textTransform: 'capitalize',
                  }}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            gap: '12px',
          }}>
          {/* Assigned Users */}
          {!isJobClose && (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
              }}>
              {assignedUsers.map((user, index) => {
                const avatarColors = ['#EBF0FF', '#FFEBEB'];
                const bgColor = avatarColors[index % avatarColors.length];
                return (
                  <div
                    key={user.id}
                    style={{
                      alignItems: 'center',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: '6px',
                      display: 'flex',
                      flexShrink: 0,
                      fontFamily: 'Red Hat Display Medium',
                      fontSize: '10px',
                      fontWeight: '500',
                      height: '32px',
                      justifyContent: 'center',
                      marginLeft: index > 0 ? '-7px' : '0',
                      overflow: 'hidden',
                      width: '32px',
                    }}>
                    <span
                      style={{
                        alignItems: 'center',
                        backgroundColor: bgColor,
                        borderRadius: '6px',
                        display: 'flex',
                        height: '28px',
                        justifyContent: 'center',
                        padding: '2px',
                        width: '28px',
                      }}>
                      {user?.assignedToFirstName?.charAt(0).toUpperCase() || ''}
                      {user?.assignedToLastName?.charAt(0).toUpperCase() || ''}
                    </span>
                  </div>
                );
              })}

              <button
                onClick={handleAssignClick}
                style={{
                  alignItems: 'center',
                  backgroundColor: '#f3f4f6',
                  border: '1px solid #e5e7eb',
                  borderRadius: '4px',
                  color: '#6b7280',
                  cursor: 'pointer',
                  display: 'flex',
                  flexShrink: 0,
                  fontSize: '12px',
                  height: '32px',
                  justifyContent: 'center',
                  marginLeft: '-5px',
                  width: '32px',
                }}>
                <AddCircleOutlineIcon sx={{ fontSize: '16px' }} />
              </button>
            </div>
          )}

          {/* Close Job Button */}
          {!isJobClose ? (
            <Button
              onClick={handleOpenCloseJobModal}
              startIcon={<CloseIcon />}
              sx={{
                '&:hover': {
                  backgroundColor: '#fef2f2',
                },
                '.MuiButton-startIcon': {
                  fontSize: '14px',
                  marginRight: '0px',
                },
                '.MuiSvgIcon-fontSizeMedium': {
                  fontSize: '15px',
                },
                backgroundColor: '#ffeeee',
                border: '1px solid #f69898',
                borderRadius: '6px',
                color: '#be0000',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 400,
                padding: '4px 6px',
                textTransform: 'none',
              }}>
              Close Job
            </Button>
          ) : (
            <Button
              onClick={handleOpenStatusView}
              startIcon={<InfoOutlinedIcon />}
              sx={{
                '&:hover': {
                  backgroundColor: '#fef2f2',
                },
                '.MuiButton-startIcon': {
                  fontSize: '14px',
                  marginRight: '4px',
                },
                '.MuiSvgIcon-fontSizeMedium': {
                  fontSize: '13px',
                },
                backgroundColor: '#ffeeee',
                border: '1px solid #f69898',
                borderRadius: '6px',
                color: '#be0000',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 400,
                padding: '4px 6px',
                textTransform: 'none',
              }}>
              Closed
            </Button>
          )}
        </div>
      </div>

      {/* Assigned Users and Actions Row */}

      {/* User Assign Modal */}
      <UserAssignModal
        open={assignModalOpen}
        onClose={handleCloseModal}
        onAssignUser={handleAssignUser}
        jobId={jobId}
        jobTitle={jobTitle}
        anchorEl={anchorEl}
        users={users}
        exisitngAssignedUsers={assignedUsers}
      />

      {/* Close Job Modal */}
      {jobData && (
        <CloseJobComponent
          open={closeJobModalOpen}
          onClose={handleCloseJobModal}
          jobData={jobData}
        />
      )}

      {/* Status View Modal (read-only, for already-closed jobs) */}
      {jobData && (
        <CloseJobComponent
          open={statusViewModalOpen}
          onClose={handleCloseStatusView}
          jobData={jobData}
          viewMode
          statusReason={statusReason}
        />
      )}
    </div>
  );
};

export default Header;
